import React, {useState} from "react";
import GoogleMicrosoftAuth from "../components/Auth/GoogleMicrosoftAuth";
import EmailStep from "../components/Auth/EmailStep";
import {Box, Paper, Stack, Typography, Divider} from "@mui/material";
import medendoLogo from "../assets/medendo_logo.png";


const Login: React.FC = () => {
    const [showGoogleMicrosoftAuth, setShowGoogleMicrosoftAuth] = useState(true);
    const [showEmailStep, setShowEmailStep] = useState(true);

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
            }}
        >
            <Paper>
                <Stack
                    justifyContent="center"
                    alignItems="stretch"
                    width={400}
                    p={2}
                >

                    <Box sx={{display: 'flex', justifyContent: 'center'}}>
                        <img src={medendoLogo} alt="Logo" width={200}/>
                    </Box>

                    {showGoogleMicrosoftAuth && <Typography variant="h6" align="center" sx={{ width: '100%' }}>Hé daar! Hoe wil je inloggen?</Typography>}
                    <Stack sx={{p: 2, width: '100%', padding: 2}}>
                    {showGoogleMicrosoftAuth && <GoogleMicrosoftAuth onMfaRequired={() => setShowEmailStep(false)}/>}   
                    {showGoogleMicrosoftAuth && <Divider sx={{my: 2}}>of</Divider>}
                    {showEmailStep && <EmailStep onStartEmailAuth={() => setShowGoogleMicrosoftAuth(false)}/>}
                        
                    </Stack>
                </Stack>
            </Paper>
        </Box>
    );
};

export default Login;
